import { Brush, Languages } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Outlet, useParams } from 'react-router-dom'
import { Separator } from '@/components/ui/separator'
import { AccountSettingsSidebarNav } from '@/features/settings/components/account-settings-sidebar-nav'

export function AccountPreferencesLayout() {
  const { t } = useTranslation('common')
  const { installationId } = useParams<{ installationId: string }>()
  const accountBase = installationId
    ? `/dashboard/${installationId}/account`
    : '/dashboard'

  const sidebarNavItems = [
    {
      title: t('settings.theme'),
      href: `${accountBase}/theme`,
      icon: <Brush size={18} />,
    },
    {
      title: t('settings.language'),
      href: `${accountBase}/language`,
      icon: <Languages size={18} />,
    },
  ]

  return (
    <div className="flex min-h-0 flex-1 flex-col overflow-hidden p-6">
      <div className="shrink-0 space-y-0.5">
        <h1 className="text-2xl font-bold tracking-tight md:text-3xl">
          {t('settings.accountPreferencesTitle')}
        </h1>
        <p className="text-muted-foreground">{t('settings.description')}</p>
      </div>
      <Separator className="my-4 shrink-0 lg:my-6" />
      <div className="flex min-h-0 flex-1 flex-col gap-2 overflow-hidden md:gap-2 lg:flex-row lg:gap-0 lg:space-x-12">
        <aside className="top-0 shrink-0 lg:sticky lg:w-1/5">
          <AccountSettingsSidebarNav items={sidebarNavItems} />
        </aside>
        <div className="flex min-h-0 w-full flex-1 overflow-y-hidden p-1">
          <Outlet />
        </div>
      </div>
    </div>
  )
}
